<template>
  <div class="vfm vfm-inset" v-show="vfmFlg" :style="{ zIndex: zIndex }">
    <div class="vfm-overlay vfm-inset" v-if="overlayFlg"></div>
    <div
      class="absolute l-0 r-0 t-0 b-0 flex justify-center items-center"
      @click="handleClose"
    >
      <div
        @click.stop=""
        class="min-w-500 vfm-content"
        :class="[show ? 'animate__zoomIn' : 'animate__zoomOut']"
      >
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  show: {
    type: Boolean,
    default: false
  },
  zIndex: {
    type: [Number, String],
    default: 1000
  },
  closeOnClickOverlay: {
    type: Boolean,
    default: false
  },
});
const vfmFlg = ref(false);
const overlayFlg = ref(false);
watch(
  () => props.show,
  nv => {
    if (nv) {
      document.body.style.height = "100vh";
      document.body.style.overflow = "hidden";
      overlayFlg.value = true;
      vfmFlg.value = true;
    } else {
      document.body.style.height = "";
      document.body.style.overflow = "";
      overlayFlg.value = false;
      setTimeout(() => {
        vfmFlg.value = false;
      }, 300);
    }
  }
);
const emit = defineEmits(["onclose"]);

function handleClose() {
  if (props.closeOnClickOverlay) {
    emit("onclose");
  }
}
</script>

<style scoped lang="scss">
.vfm {
  position: fixed;

  .vfm-overlay {
    background: rgba(48, 47, 47, 0.6);
    position: absolute;
    backdrop-filter: blur(10px);
  }
}
.vfm-inset {
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}
.animate__zoomIn {
  animation: zoomIn 0.5s both;
}
.animate__zoomOut {
  animation: zoomOut 0.3s both;
}

@keyframes zoomIn {
  0% {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }

  50% {
    opacity: 1;
  }
  100% {
    transform: scale3d(1, 1, 1);
  }
}
@keyframes zoomOut {
  0% {
    transform: scale3d(1, 1, 1);
  }

  80% {
    transform: scale3d(0.1, 0.1, 0.1);
  }
  100% {
    opacity: 0;
  }
}

</style>
